const privilegeManager = (payload, moduleName, subModule, privilege) => {
  const { appModules } = payload;
  const appModule = appModules[moduleName];
  return subModule && privilege
    ? appModule[subModule][privilege]
    : appModule.hasPrivilege;
};
export default privilegeManager;
